import { atom as e } from "recoil";
const l = {
  userId: "",
  username: "",
  country: "",
  roles: [],
  languageCode: "",
  openStates: 0,
  groupName: "",
  additionalFields: null,
  additionalFields2: null,
  allowAutoUpdate: null,
  allowRemoteDispatch: null,
  isGroupAdmin: 0,
  licenseNo: null,
  mailBox: "",
  orderType: 0,
  separator: "",
  userType: "",
  dot: "",
  coId: ""
}, a = e({ key: "userState", default: l });
export {
  a as default,
  l as defaultUserState
};
